import { createFileRoute, redirect } from "@tanstack/react-router";
import { ControlCodes, queries } from "@theprelude/core";
import { Button, ExternalLinkIcon } from "@theprelude/ds";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { AdvisoriesLoading } from "@/components/threat-intel/advisories-loading";
import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/threat-intel/import/feed-notice")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Threat Intel");
    const account = await context.queryClient.ensureQueryData(
      queries.iam.getAccount(await context.auth.getAuthConfig()),
    );
    await authorizeFeatures(context, ["detect", "threat_intel"]);

    const hasCrowdstrike = account.controls.some(
      (c) => c.id === ControlCodes.CROWDSTRIKE,
    );

    if (hasCrowdstrike) {
      throw redirect({ to: "/threat-intel/import/feed" });
    }
  },
  component: FeedNotice,
  pendingComponent: AdvisoriesLoading,
});

function FeedNotice() {
  return (
    <div className="mx-auto flex h-screen max-w-[600px] flex-col items-center justify-center gap-6 text-base">
      <div className="text-foreground-primary border-b border-b-stroke-line pb-4 text-sm">
        Premium Feature
      </div>
      <img
        className="size-72"
        src="/images/falcon.png"
        alt="CrowdStrike Falcon Threat Intel Premium"
      />
      <div className="text-center text-3xl">
        This feature is only available for CrowdStrike Falcon Threat Intel
        Premium users.
      </div>
      <div className="text-center">
        Upgrade your CrowdStrike account to access this feature or enter your
        API key.
      </div>
      <a
        href="https://support.preludesecurity.com/docs/crowdstrike#falcon-threat-intelligence"
        target="_blank"
        rel="noreferrer"
      >
        <Button
          intent="secondary"
          icon={<ExternalLinkIcon className="text-secondary-foreground" />}
        >
          Learn more
        </Button>
      </a>
    </div>
  );
}
